const STORAGE_KEY = "kd_favorites";
const EVENT_NAME = "kd:favorites:changed";

export default class FavoritesService {
    static _hasWindow() {
        return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
    }

    static getAll() {
        if (!this._hasWindow()) return [];

        try {
            const raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) return [];

            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) return [];

            return parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id));
        } catch {
            return [];
        }
    }

    static _save(ids) {
        if (!this._hasWindow()) return;

        const clean = Array.from(
            new Set(ids.map((id) => Number(id)).filter((id) => Number.isFinite(id)))
        );

        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
        window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { favorites: clean } }));

        return clean;
    }

    static isFavorite(productId) {
        const id = Number(productId);
        if (!Number.isFinite(id)) return false;

        return this.getAll().includes(id);
    }

    static toggle(productId) {
        const id = Number(productId);
        if (!Number.isFinite(id)) return false;

        const current = this.getAll();
        const exists = current.includes(id);

        const next = exists ? current.filter((v) => v !== id) : [...current, id];

        const saved = this._save(next);
        return saved.includes(id);
    }

    static clear() {
        if (!this._hasWindow()) return;
        this._save([]);
    }
    static count() {
        return this.getAll().length;
    }
}

export { EVENT_NAME as FAVORITES_EVENT, STORAGE_KEY as FAVORITES_STORAGE_KEY };
